import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from '@heroicons/react/24/solid';
import diverseGroup from '../assets/diverse-group-business-professionals-posing-together-monitoring-room_482257-94131.jpg_kxystx.jpg';
import teamMeeting from '../assets/diverse-teammates-examining-statistics-infographics-computer_482257-90942.jpg_z2rlyq.jpg';
import businessAnalyst from '../assets/business-analyst-looking-into-statistics-reports-detect-any-obstacles_482257-110400.jpg_qxkemx.jpg';

const TeamTestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      title: "Investment Manager",
      rating: 5,
      text: "The level of personal attention and expertise I receive from Segway Capital is unmatched. They truly understand my investment goals and provide tailored solutions.",
      image: diverseGroup
    },
    {
      name: "Michael Chen",
      title: "Tech Entrepreneur",
      rating: 5,
      text: "As someone who values both innovation and security, Segway Capital delivers on both fronts. Their platform is cutting-edge yet reliable.",
      image: teamMeeting
    },
    {
      name: "Emily Rodriguez",
      title: "Financial Advisor",
      rating: 5,
      text: "I've been working with Segway Capital for over two years now. Their customer service is exceptional and their platform is incredibly user-friendly.",
      image: businessAnalyst
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 1.2, 
            ease: [0.25, 0.46, 0.45, 0.94],
            delay: 0.2 
          }}
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-12 lg:mb-16"
        >
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-6"
          >
            Our dedicated team is available seven days a week to provide personal assistance.
          </motion.h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ 
                duration: 1, 
                ease: [0.25, 0.46, 0.45, 0.94],
                delay: index * 0.2 
              }}
              viewport={{ once: true, margin: "-50px" }}
              whileHover={{ 
                y: -8, 
                scale: 1.02,
                transition: { duration: 0.3, ease: "easeOut" }
              }}
              className="group"
            >
              <motion.div 
                className="bg-teal-50 rounded-2xl p-6 lg:p-8 border border-teal-200 shadow-sm hover:shadow-lg transition-all duration-500 ease-out"
                whileHover={{ 
                  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  borderColor: "#0d9488"
                }}
              >
                {/* Stars */}
                <motion.div 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.4 }}
                  viewport={{ once: true }}
                  className="flex items-center mb-4"
                >
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <StarIcon key={i} className="w-5 h-5 text-yellow-400" />
                  ))}
                </motion.div>

                {/* Testimonial Text */}
                <motion.p 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.6 }}
                  viewport={{ once: true }}
                  className="text-gray-700 text-base lg:text-lg mb-6 italic leading-relaxed"
                >
                  "{testimonial.text}"
                </motion.p>

                {/* Author */}
                <motion.div 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.8 }}
                  viewport={{ once: true }}
                  className="flex items-center"
                >
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.title}</p>
                  </div>
                </motion.div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamTestimonialsSection; 